export class Toaster {
  static success = (addToast: any, message: string) => {
    addToast(message, {
      appearance: "success",
    });
  };

  static error = (addToast: any, message: string) => {
    addToast(message, {
      appearance: "error",
    });
  };

  static warning = (addToast: any, message: string) => {
    addToast(message, {
      appearance: "warning",
    });
  };

  static info = (addToast: any, message: string) => {
    addToast(message, {
      appearance: "info",
    });
  };
}
